import _ from "lodash";
import { topCountriesMetaSelector } from "../../umbilical_hocs/selector";
import {
  fetchAddOnDetails,
  fetchAddOnsPromo,
  fetchCountriesInfo,
  fetchGuestProfile,
  fetchPackageDetails,
  fetchPackagesPromo,
  fetchWebsiteMeta,
} from "../../api";
import {
  COUNTRIES_INFO_SAVE,
  FEATURED_PACKAGE_SAVE,
  GUESTPROFILE_RESET,
  GUESTPROFILE_SAVE,
  MAINPROMO_ITEMS_SAVE,
  TOUR_DATA_SAVE,
  TOUR_IDLE,
  TOUR_LOADING,
  WEBSITEMETA_IDLE,
  WEBSITEMETA_LOADING,
  WEBSITEMETA_SAVE,
} from "./types";
import { retrieveRestaurant } from "../../api/restaurants";

var api_key = import.meta.env.VITE_APP_WEBSITE_KEY;

export const getWebsiteMeta = () => async (dispatch) => {
  const metadata = await fetchWebsiteMeta(api_key);
  if (metadata) {
    dispatch(saveWebsiteMeta(metadata));
  }
};

export const saveWebsiteMeta = (metadata) => {
  return { type: WEBSITEMETA_SAVE, metadata };
};

export const loadingWebsiteMeta = () => {
  return { type: WEBSITEMETA_LOADING };
};

export const idleWebsiteMeta = () => {
  return { type: WEBSITEMETA_IDLE };
};

async function fetchPromoRestaurants({ references }) {
  const promises = references.map((ref) => retrieveRestaurant({ rid: ref }));
  return Promise.all(promises);
}

export const getMainPromoItems = () => async (dispatch, getState) => {
  const state = getState();

  const source_entity = _.get(state, "WebsiteMetadata.metadata.source_entity");

  const { packages, addons, accommodation } =
    state?.WebsiteMetadata?.metadata ?? {};

  const references__in = _.get(
    state,
    "WebsiteMetadata.metadata.landing_page.main_promo.references",
    []
  ).join(",");

  const package_references__in = _.get(
    state,
    "WebsiteMetadata.metadata.landing_page.main_promo.package_references",
    []
  ).join(",");

  const hotel_references__in = _.get(
    state,
    "WebsiteMetadata.metadata.landing_page.main_promo.hotel_references",
    []
  ).join(",");

  const restaurant_references = _.get(
    state,
    "WebsiteMetadata.metadata.landing_page.restaurant_promo.references",
    []
  ).map((ref) => ref[0]);

  var results = [];
  if (addons) {
    const addons = await fetchAddOnsPromo({ source_entity, references__in });
    if (Array.isArray(addons)) {
      results = [
        ...results,
        ...addons.map((pkg) => {
          pkg.product_type = "MI";
          return pkg;
        }),
      ];
    }
  }

  if (packages) {
    results = [
      ...results,
      ...(
        (await fetchPackagesPromo({
          references__in: package_references__in,
        })) || []
      ).map((pkg) => {
        pkg.product_type = "PKG";
        return pkg;
      }),
    ];
  }

  if (accommodation) {
    results = [
      ...results,
      ...(
        (await fetchPackagesPromo({
          references__in: hotel_references__in,
        })) || []
      ).map((pkg) => {
        pkg.product_type = "ACC";
        return pkg;
      }),
    ];
  }

  if (restaurant_references.length) {
    results = [
      ...results,
      ...(
        (await fetchPromoRestaurants({ references: restaurant_references })) ||
        []
      ).map((rest) => {
        rest.product_type = "REST";
        return rest;
      }),
    ];
  }

  if (results) {
    dispatch(saveMainPromoItems(results));
  }
};

export const getFeaturedPkg = () => async (dispatch, getState) => {
  const state = getState();

  const package_references__in = _.get(
    state,
    "WebsiteMetadata.metadata.landing_page.main_promo.featured_package",
    ""
  );

  var results = [
    ...(
      (await fetchPackagesPromo({
        references__in: package_references__in,
      })) || []
    ).map((pkg) => {
      pkg.product_type = "PKG";
      return pkg;
    }),
  ];

  if (results.length > 0) {
    dispatch(saveFeaturedPkg(results[0]));
  }
};

const saveFeaturedPkg = (pkg) => {
  return { type: FEATURED_PACKAGE_SAVE, pkg };
};

const saveMainPromoItems = (items) => {
  return { type: MAINPROMO_ITEMS_SAVE, items };
};

export const tourLoading = () => {
  return { type: TOUR_LOADING };
};

export const tourIdle = () => {
  return { type: TOUR_IDLE };
};

export const getAddonDetails =
  (reference, product_type, source_entity) => async (dispatch, getState) => {
    dispatch(tourLoading());

    var details = null;
    if (product_type === "MI") {
      details = await fetchAddOnDetails(reference, source_entity);
    } else if (product_type === "PKG") {
      details = await fetchPackageDetails({
        reference,
        source_entity,
        api_key,
      });
    }

    if (details) {
      details["product_type"] = product_type;
      await dispatch(saveTourDetails(details));
    }
    dispatch(tourIdle());
  };

const saveTourDetails = (details) => {
  return { type: TOUR_DATA_SAVE, details };
};

export const getCountriesInfo = () => async (dispatch, getState) => {
  const { country_codes } = topCountriesMetaSelector(getState());
  const result = await fetchCountriesInfo(country_codes);

  const country_info = {};
  result.forEach((country) => (country_info[country.code] = country));
  dispatch({ type: COUNTRIES_INFO_SAVE, country_info });
};

// ========================= PROFILE ACTIONS =========================

export const getGuestProfile = (user_id) => async (dispatch) => {
  const guestProfile = await fetchGuestProfile(user_id);
  if (guestProfile) {
    dispatch(saveGuestProfile(guestProfile));
  }
};

export const saveGuestProfile = (guestProfile) => {
  return { type: GUESTPROFILE_SAVE, guestProfile };
};

export const resetGuestProfile = () => {
  return { type: GUESTPROFILE_RESET };
};
